import { config } from '@yola/ws-sdk';

export default config.selectors.getSupportedLocales;
